namespace $.$$ {
	$mol_style_define($bog_qr, {
		width: '300px',
		height: '300px',
		Center_body: {
			width: '80%',
			height: '80%',
			position: 'absolute',
			top: '10%',
			left: '10%',
		},
	})
}
